const MARITAL_STATUS = ["Single", "Married", "Divorced", "Widowed"];

export default MARITAL_STATUS;
